import { render, staticRenderFns } from "./OccupiersQuestionnaire.vue?vue&type=template&id=516b8987&"
import script from "./OccupiersQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./OccupiersQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports